<template lang="pug">
.calendar(:class="{old_demo_transactions: old_demo_transactions}")
  transaction_tooltip(v-if='!HM.is_touch')
  filters(:all_trs='all_trs' mode='calendar')
  .notification.is-warning(v-if='more_than_year_ahead' style='margin-top: 1rem;') {{ $t('calendar_one_year') }}
  .notification.is-info(v-if='no_transactions' style='margin-top: 1rem;') {{ $t('calendar_no_transactions') }}
  .calendar_table
    .title.is-1.demo_transactions_text {{ $t('demo_transactions_text') }}
    .days
      .week(v-for='(week, index) in dates.weeks')
        hm_day(:day='day', :transactions='transactions_by_days[day.dateIso] || []', v-for='day in week', :key='day.dateIso', :week_index='index')
    display_options(v-if='!HM.is_mobile')
</template>

<script>
import TransactionsFilter from './transactions/filter.coffee'
import DaysBuilder from './calendar/days_builder.coffee'

export default {
  name: 'calendar',
  metaInfo()  {
    return { title: this.$t('Calendar') }
  },
  components: {
    hm_day:          require('./calendar/day.vue').default,
    display_options: require('./calendar/display_options.vue').default,
    filters:         require('./calendar/filters.vue').default,
    transaction_tooltip: require('./calendar/transaction_tooltip.vue').default,
  },
  data() {
    return {
      all_trs: null,
      transactions_by_days: {},
      old_demo_transactions: false
    };
  },
  mounted() {
    this.$watch('$route.query.month', this.changeMonth, { immediate: true });
    this.$watch('filter', this.filterTransactions, { deep: true, immediate: false });
    this.$watch('$store.state.user.transactions', this.findTransactions, { deep: true });
  },
  activated() { this.findTransactions() },
  deactivated() { return this.$store.dispatch('hideTransactionsPopovers'); },
  computed: {
    filter() { return this.$store.state.ui.transactions.calendar.filter; },
    current_month() { return this.$store.state.ui.transactions.calendar.current_month; },
    dates() {
      if (!this.current_month) { return { weeks: [] }; }
      const weeks = DaysBuilder.build(this.current_month);
      return {
        weeks,
        start: _.first(weeks)[0].dateIso,
        end  : _.last(weeks)[6].dateIso
      };
    },
    more_than_year_ahead() { return this.current_month >= hm_date.constants.year_from_now_start_of_month; },
    no_transactions() {
      return this.all_trs && this.all_trs.length == 0
    }
  },
  methods: {
    findTransactions() {
      if (!this.$route.name.includes('calendar')) { return; }
      this.all_trs = this.$store.state.user.transactions.filter(tr =>
        (this.dates.start <= tr.date) && (tr.date <= this.dates.end)
      );
      this.$store.commit('TRANSACTIONS/CALENDAR/ALL', this.all_trs);
      return requestIdleCallback(this.filterTransactions);
    },
    filterTransactions() {
      let res = TransactionsFilter(this.all_trs, this.filter);
      res = _.orderBy(res, function(tr) {
        if (_.isNumber(tr.real_amount)) { return tr.real_amount; } else { return tr.plan_amount; }
      });
      this.$store.commit('TRANSACTIONS/CALENDAR/FILTERED', this.findCurrentMonthTrs(res));
      return this.transactions_by_days = _.groupBy(res, 'date');
    },
    changeMonth(value) {
      this.$store.dispatch('selectTransaction', {});
      if (!hm_date.isValid(hm_date.parse(value))) { value = null; }
      if (!value) { value = this.current_month || hm_date.constants.start_of_current_month; }
      this.$store.commit('CALENDAR/CHANGE_MONTH', value);
      requestIdleCallback(this.findTransactions);
      return this.old_demo_transactions = (this.current_month < hm_date.addMonths_f(new Date, -2)) && HM.is_demo;
    },
    findCurrentMonthTrs(trs) {
      return trs.filter(tr =>
        (hm_date.startOfMonth_f(this.current_month) <= tr.date) && (tr.date <= hm_date.endOfMonth_f(this.current_month))
      )
    }
  }
};
</script>

<style lang="sass">
.mobile .calendar
  .days
    min-width: 750px
  .calendar_table
    overflow: scroll
    padding-bottom: 0
.calendar
  *:not(input):not(textarea)
    -webkit-touch-callout: none // disable the IOS popup when long-press on a link
    // Disable selection/Copy of UIWebView
    user-select: none
  .days
    border-left: 1px solid rgb(217, 208, 191)
    border-top: 1px solid rgb(217, 208, 191)
  .week
    display: flex
    border-bottom: 1px solid rgb(217, 208, 191)
  .calendar_table
    position: relative
    padding-bottom: 4em
  .demo_transactions_text
    display: none
    position: absolute
    z-index: 30
    text-align: center
    width: 100%
    transform: rotate(-15deg)
    top: 300px
    left: auto
  &.old_demo_transactions
    .transaction, .el-tooltip__popper
      opacity: 0.2
    .demo_transactions_text
      display: block
</style>

<i18n>
ru:
  demo_transactions_text: 'Старые демо-транзакции'
  calendar_no_transactions: 'Щёлкните по дню календаря, чтобы внести доход/расход/перевод'
  calendar_one_year: 'Система отображает и просчитывает запланированные доходы/расходы только на год вперёд от текущей даты'
en:
  demo_transactions_text: 'Old Demo Transactions Here'
  calendar_no_transactions: 'Click on any day to enter incomes/expenses/transfers'
  calendar_one_year: 'Calendar displays planned transactions only for one year in future'
</i18n>
